import { FC } from 'react';

import { Tabs } from '@awsui/components-react';

import UserWorkSpacePendingDecommissionRequestTable from '../userWorkSpacePendingDecommissionRequestTable';
import UserWorkSpaceAllDecommissionRequestTable from '../userWorkSpaceAllDecommissionRequestTable';

interface ViewProps {}

const View: FC<ViewProps> = () => {
  return (
    <Tabs
      variant="container"
      tabs={[
        {
          label: 'Pending',
          id: 'pending',
          content: <UserWorkSpacePendingDecommissionRequestTable />
        },
        {
          label: 'All',
          id: 'all',
          content: <UserWorkSpaceAllDecommissionRequestTable />
        }
      ]}
    />
  );
};
export default View;
